module.exports = __webpack_public_path__ + "img/we-1.626a0390.jpg";